import { render } from "./CustomerOrders.vue?vue&type=template&id=f6450d3e"
import script from "./CustomerOrders.vue?vue&type=script&lang=js"
export * from "./CustomerOrders.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__